import { combineReducers } from 'redux'
import { createBrowserHistory } from 'history'
import { connectRouter } from 'connected-react-router'

import { IMainState } from '../states'
import { reducer as application } from './application.reducer'
import { reducer as hierarchy } from './hierarchy.reducer'
import { reducer as courses } from './course.reducer'
import { reducer as externalCourses } from './externalCourse.reducer'
import { reducer as externalCourseParticipants } from './externalCourseParticipant.reducer'
import { reducer as externalCoursesEnrolled } from './externalCourseEnrolled.reducer'
import { reducer as externalCourseCertificate } from './externalCourseCertificate.reducer'
import { reducer as lmsProfiles } from './lmsProfile.reducer'
import { reducer as user } from './user.reducer'
import { reducer as enrols } from './enrol.reducer'
import { reducer as questionTypes } from './questionTypes.reducer'
import { reducer as blocks } from './blocks.reducer'
import { reducer as lessons } from './lesson.reducer'
import { reducer as lmsLessons } from './lessons.reducer'
import { reducer as questions } from './question.reducer'
import { reducer as monitoring } from './monitoring.reducer'
import { reducer as answer } from './answer.reducer'
import { reducer as areas } from './areas.reducer'
import { reducer as participants } from './participants.reducer'
import { reducer as chat } from './chat.reducer'
import { reducer as access } from './access.reducer'
import { reducer as folders } from './folder.reducer'
import { reducer as certificate } from './certificate.reducer'
import { reducer as general } from './general.reducer'
import { reducer as requestOutsideCourses } from './requestOutsideCourses.reducer'
import { reducer as progressLessonContent } from './blockProgress.reducer'

export const history = createBrowserHistory()

export const createRootReducer = (history: any) =>
  combineReducers<IMainState>({
    application,
    hierarchy,
    courses,
    externalCourses,
    externalCourseParticipants,
    externalCoursesEnrolled,
    externalCourseCertificate,
    lmsProfiles,
    user,
    participants,
    general,
    requestOutsideCourses,
    questionTypes,
    blocks,
    enrols,
    lessons,
    lmsLessons,
    monitoring,
    answer,
    questions,
    chat,
    access,
    areas,
    folders,
    certificate,
    progressLessonContent,
    router: connectRouter(history),
  })
